<template>
    <div class="pay-step text-center">
        <p class="upload-tips text-info">导入说明：请下载 <a href="http://jinsuizhiguan.oss-cn-beijing.aliyuncs.com/templet/%E7%B3%BB%E7%BB%9F%E7%BB%93%E7%AE%97%E6%A8%A1%E6%9D%BF.xlsx" class="upload_link">结算模板</a>，在模板中添加好数据再进行导入.</p>
        <el-upload
            class="upload-demo__huge"
            drag
            name="payment"
            :headers="headers"
            :on-success="uploadSuccess"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
            :action="actionUrl">
            <i class="iconfont icon-shangchuanwenjian"></i>
            <div class="el-upload__text">
                点击或将文件拖拽到这里
                <div class="btn-wraper">
                    <el-button type="primary">
                        上传文件
                    </el-button>
                </div>
            </div>
        </el-upload>
        <div class="features">
            <div class="feature-box">
                <div class="feature-box__icon">
                    <v-svg-icon name="icon-renlianshibie" class="svg-icon" />
                </div>
                <div class="feature-box__desc text-primary">
                    Excle中的内容<br>智能识别
                </div>
            </div>
            <div class="feature-box">
                <div class="feature-box__icon">
                    <v-svg-icon name="icon-yuangong" class="svg-icon" />
                </div>
                <div class="feature-box__desc text-primary">
                    成员签约状态<br>审核验证
                </div>
            </div>
            <div class="feature-box">
                <div class="feature-box__icon">
                    <v-svg-icon name="icon-yinhang" class="svg-icon" />
                </div>
                <div class="feature-box__desc text-primary">
                    所有银联银行卡<br>全部支持
                </div>
            </div>
            <div class="feature-box">
                <div class="feature-box__icon">
                    <v-svg-icon name="icon-anquanbaozhang" class="svg-icon" />
                </div>
                <div class="feature-box__desc text-primary">
                    128位SSL技术<br>加密保护
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router'
export default {
    name: 'Step1',
    data () {
        return {
            actionUrl: process.env.VUE_APP_BASE + '/api/user/payment/upload',
            headers: {},
            form: {
                project: ''
            }
        }
    },
    mounted () {
        this.headers = { token: localStorage.getItem('token') }
    },
    methods: {
        uploadSuccess (res) {
            if (res.code === 0) {
                router.push('/index/pay/home/step2?path=' + res.data.fullpath)
            } else {
                this.$message.error(res.message)
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
    .pay-step {
        .upload-tips {
            margin: 60px 0 40px;
        }
    }
    .features {
        display: flex;
        width: 740px;
        margin: 35px auto;
        .feature-box {
            flex: 1;
            text-align: center;
            .feature-box__icon {
                .svg-icon {
                    font-size: 36px;
                }
            }
            .feature-box__desc {
                margin-top: 13px;
                line-height: 1.5;
            }
        }
    }
</style>
